export default __webpack_public_path__ + "static/media/letter-icon.85e9e13b.svg";